import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelCatDefault: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" height="170" width="255" {...props} xmlns="http://www.w3.org/2000/svg">
    <path fill="#BB9260" d="M31.442 109.308l75.499 37.525v2.581l132.642-23.767v-2.579l-75.498-37.526-132.643 23.766z" />
    <path
      fill="url(#parcel_cat_paint0_linear)"
      d="M75.807 154.977l31.134-5.564-75.5-37.524L.903 117.39l74.905 37.587z"
    />
    <path
      fill="#9E7548"
      d="M237.51 122.002l-3.936-1.922-132.983 23.596-3.431-1.704 132.983-23.597-3.886-1.931L93.276 140.04l-3.432-1.704 132.983-23.598-3.886-1.93-132.982 23.596-3.432-1.704 132.984-23.598-3.882-1.932-132.986 23.598-3.43-1.705 132.978-23.598-3.884-1.931-132.98 23.598-3.434-1.707 132.983-23.596-3.886-1.931-132.982 23.596-3.432-1.705 132.985-23.597-3.883-1.93-132.986 23.596-3.43-1.705 132.982-23.597-3.878-1.932-132.99 23.598-3.432-1.705L178.928 92.92l-3.884-1.931L42.06 114.585l-3.435-1.707 132.983-23.596-3.884-1.93L34.74 110.946l-3.3-1.639v2.581l47.225 23.472.004.023.033-.006 7.228 3.593.01.057.077-.014 7.177 3.567.017.091.123-.021 13.606 6.763v-2.582l-2.465-1.225 133.035-23.605z"
    />
    <path
      fill="url(#parcel_cat_paint1_linear)"
      d="M94.127 133.205l27.188-4.933-29.85-14.899-27.348 4.853 30.01 14.979z"
    />
    <path fill="#C39000" d="M121.306 69.999v58.273l-29.967-14.894V55.104l29.967 14.895z" />
    <path fill="#FBCE08" d="M121.306 69.999v58.272l52.65-9.433V60.565L121.306 70z" />
    <path fill="#fff" d="M146.769 104.442v12.736l21.987-3.948v-12.735l-21.987 3.947z" />
    <path
      fill="#000"
      d="M159.449 112.423l3.855-.676v-7.596l-3.855.676v7.596zM.902 154.977h238.681V17.324H.902v137.653zm0-137.653h238.681v137.653H.902V17.324z"
    />
    <path
      fill="#000"
      d="M148.847 114.28c1.121-.196 2.195-.385 3.26-.573v-7.595c-1.108.195-2.168.38-3.26.573v7.595zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#000"
      d="M155.716 113.078l1.606-.282v-7.589l-1.606.282v7.589zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#000"
      d="M166.682 103.556c-.562.099-1.087.191-1.638.286v7.598l1.638-.286v-7.598zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#000"
      d="M153.873 113.407l.656-.115v-7.595a141.2 141.2 0 01-.656.115v7.595zM.902 154.976h238.682V17.324H.902v137.652zm0-137.652h238.682v137.652H.902V17.324z"
    />
    <path
      fill="url(#parcel_cat_paint2_linear)"
      fillOpacity=".6"
      d="M112.601 96.54l53.676-23.876-7.278-6.112-10.061-3.02-59.337 1.443 23 31.565z"
    />
    <path
      fill="url(#parcel_cat_paint3_linear)"
      fillOpacity=".6"
      d="M121.373 80.907l28.558-8.136-7.278-6.112-10.06-3.02-43.71 1.064 32.49 16.204z"
    />
    <path fill="#926607" d="M121.306 70l52.65-9.435-29.968-14.894-52.649 9.434 29.967 14.894z" />
    <path
      fill="#C8C9C8"
      d="M178.126 64.581c1.117 2.799-2.594 6.913-8.29 9.189-5.697 2.276-11.22 1.852-12.338-.947-1.118-2.8 2.593-6.913 8.289-9.189 3.009-1.202 4.359-3.659 6.648-3.402 2.044.23 5.163 3.03 5.691 4.35zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#C8C9C8"
      d="M102.309 21.464c3.139-2.455 8.049-4.072 13.594-4.072 4.718 0 8.989 1.156 12.08 3.025 3.091 1.868 7.357 5.1 14.576 3.217l6.652 43.962-17.038 2.025s-27.668 3.165-36.58-2.052c0 0-9.863-11.23-4.28-31.132 0 0 1.591-7.618 10.996-14.973zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#B8B8B8"
      d="M95.539 67.524s4.841-5.018 9.54-5.71c4.7-.691 9.774 2.74 12.577 2.3 8.791-1.378 14.992-11.5 14.992-11.5s4.82 6.216 9.911 12.643c4.929 6.223 2.598 1.945 2.598 1.945l12.142-3.087-3.087 3.608s-8.776 1.553-9.881 1.553c-1.105 0-16.727.767-17.214.803-.486.036-23.787 2.371-31.578-2.555zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#C8C9C8"
      d="M152.421 72.107c-.531 2.967-5.856 4.495-11.895 3.413-6.037-1.082-10.501-4.363-9.969-7.33.531-2.966 5.857-4.495 11.895-3.413 6.038 1.081 10.502 4.364 9.969 7.33zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#B8B8B8"
      d="M151.712 70.387c-.442 1.35-2.602 1.856-4.826 1.129-2.035-.665-7.398-6.157-7.175-7.058l.368.023c.579 0 2.723.145 8.403 2.148 1.032.363 1.592 1.002 2.18 1.623.669.707 1.284 1.417 1.05 2.135zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#B8B8B8"
      d="M158.475 68.575c.441 1.35 2.681 1.428 4.905.702 2.223-.726 10.679-7.714 10.239-9.064-.44-1.35-9.692 3.877-11.915 4.604-2.224.726-3.669 2.408-3.229 3.758zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#B8B8B8"
      d="M104.668 19.97c-.2.114-18.35 10.838-3.664 15.772 14.686 4.933 22.483-17.277 22.483-17.277s-10.238-3.385-18.819 1.504zM.902 154.976h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#B8B8B8"
      d="M124.136 50.799c0 3.426-3.599 6.205-8.039 6.205-4.44 0-8.039-2.779-8.039-6.205 0-3.427 3.599-6.204 8.039-6.204 4.44 0 8.039 2.777 8.039 6.204zM.902 154.977h238.682V17.324H.902v137.653zm0-137.653h238.682v137.653H.902V17.324z"
    />
    <path
      fill="#E4E4E4"
      d="M166.885 26.745c.085-.115 6.224-6.996 6.224-6.996s2.159-1.91 2.413 1.529l-.804 12.801-7.833-7.334zM.902 153.849h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#C8C8C8"
      d="M168.98 26.314c.048-.064 3.48-3.912 3.48-3.912s1.208-1.068 1.35.855l-.451 7.156-4.379-4.1zM.902 153.849h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#B8B8B8"
      d="M172.996 22.12c.342-.07.735.089.813 1.136l-.451 7.157-.362-8.293zM.902 153.85h238.681V16.196H.902V153.85zm0-137.653h238.681V153.85H.902V16.196z"
    />
    <path
      fill="#E4E4E4"
      d="M180.281 43.689c0 13.342-11.166 24.159-24.939 24.159s-24.938-10.817-24.938-24.159c0-13.342 11.165-24.16 24.938-24.16s24.939 10.818 24.939 24.16zM.902 153.849h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#E4E4E4"
      d="M140.506 30.413l.115-9.81c.722-3.746 3.636-1.353 3.636-1.353s3.144 3.245 5.55 5.733l-9.301 5.43zM.902 153.849h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#C8C8C8"
      d="M149.201 26.484c-1.478-1.53-4.348-4.494-4.348-4.494s-1.771-1.454-2.211.822l-.076 6.571 6.635-2.899zM.902 153.85h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#B8B8B8"
      d="M146.42 27.692l2.781-1.207c-1.478-1.53-4.348-4.494-4.348-4.494s-.692-.568-1.318-.438c0 0 .72.461 1.291 1.295.428.625.781 1.608.781 1.608l.584 2.193.229 1.043zM.902 153.85h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#C8C8C8"
      d="M175.025 33.72c-1.584 3.039-6.75 3.478-11.538.982-4.789-2.497-7.385-6.984-5.802-10.023 1.585-3.038 6.751-3.477 11.539-.981 4.789 2.497 7.385 6.983 5.801 10.022zM.902 153.85h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#C8C8C8"
      d="M173.97 48.943l.133-.436c-4.817-1.487-9.717.404-9.765.423l.084.212.019.227c.041.002 4.191-.27 9.131 2.318l.213-.402c-3.347-1.755-6.258-2.223-7.919-2.34 1.741-.45 4.921-.987 8.104-.002zM.902 153.85h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#C8C8C8"
      d="M156.801 49.34c-.058-.024-5.706-2.21-11.006.025l.178.421c3.599-1.518 7.335-.926 9.282-.432-1.704.122-4.705.613-8.138 2.465l.217.4c5.041-2.718 9.329-2.442 9.364-2.44l.018-.228.085-.211zM.902 153.849h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#8E8E8E"
      d="M167.985 49.975a.348.348 0 00-.43.224c-.02.066-.541 1.635-2.681 2.04-2.217.426-3.269-.69-4.01-1.828-.022-.035-.063-.04-.095-.064-.028-.023-.042-.058-.078-.07-.008-.004-.016.003-.024 0-.045-.013-.086.001-.133.007-.043.007-.082.002-.119.024-.007.003-.018-.002-.025.003-.035.022-.04.062-.063.092s-.06.044-.073.08c-.025.068-.616 1.647-3.015 2.066-2.517.435-3.672-.678-4.496-1.822a.346.346 0 00-.48-.075.341.341 0 00-.079.476c.766 1.058 1.893 2.202 3.998 2.202.36 0 .751-.034 1.172-.108 1.943-.339 2.867-1.358 3.269-1.99.666.882 1.664 1.78 3.354 1.78a5.6 5.6 0 001.025-.101c2.556-.485 3.181-2.428 3.207-2.51a.34.34 0 00-.224-.426zM.902 153.849h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#D20612"
      d="M160.692 51.123l-3.391-3.427h6.413l-3.022 3.427zM.902 153.85h238.682V16.196H.902V153.85zm0-137.653h238.682V153.85H.902V16.196z"
    />
    <path
      fill="#000"
      d="M152.024 42.58a1.642 1.642 0 11-3.284 0 1.642 1.642 0 013.284 0zM170.136 42.58a1.642 1.642 0 11-3.284 0 1.642 1.642 0 013.284 0z"
    />
    <path
      fill="#C8C9C8"
      d="M92.003 54.61s-13.794 3.844-14.6 17.238c0 0-1.073 12.935 16.956 15.602 0 0 17.903 3.76 19.307-4.947 0 0 1.104-10.158-6.677-8.293-3.218.499-9.07.76-11.586-.414 0 0-3.809-2.565.763-6.92L92.003 54.61z"
    />
    <path
      fill="#B8B8B8"
      d="M99.495 64.283s-11.926 1.129-9.644 7.518c0 0 1.028 2.376 7.22 2.5 0 0-1.5-.26-2.078-.863-.857-.892-2.143-2.92.545-5.916 0 0 2.655-2.56 3.957-3.239z"
    />
    <defs>
      <linearGradient
        id="parcel_cat_paint0_linear"
        x1="43.063"
        x2="54.59"
        y1="140.213"
        y2="116.837"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_paint1_linear"
        x1="75.804"
        x2="87.08"
        y1="123.063"
        y2="100.288"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9E7549" stopOpacity="0" />
        <stop offset=".5" stopColor="#4F3A24" stopOpacity=".5" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_paint2_linear"
        x1="122.526"
        x2="148.683"
        y1="98.976"
        y2="43.278"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCCE09" stopOpacity="0" />
        <stop offset=".5" stopColor="#7E6705" stopOpacity=".5" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_paint3_linear"
        x1="101.366"
        x2="113.544"
        y1="75.655"
        y2="47.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C39000" stopOpacity="0" />
        <stop offset=".5" stopColor="#614800" stopOpacity=".5" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
